module.exports = __webpack_public_path__ + "static/media/245-jersey.164b98fa.svg";